export default "__VITE_ASSET__CnUPKRUO__"